// bulma docs https://dev.to/1n0t/creacion-de-un-proyecto-svelte-bulma-sass-1o8i
// import "../styles.bulma.scss";
import App from '../Register.svelte';
let app = document.querySelector(".register-gadget-3pod");

app.classList.add("active", "section-widget-svelte");
let application = new App({
	target: app,
});

/*
app.classList.add("active", "section-widget-svelte");

let mounted = turpial.mount(app, `<register-module class="svelte-app-child index-module"></register-module>`);
console.log(mounted)

app = mounted.attachShadow({mode: 'open'});

let application = new App({
	target: app,
});

ShadowRoot.update(app.querySelector(".svelte-module"));

let styles = document.querySelector("#injected-css-sv");
app.appendChild(styles);
*/
/*
let styles = document.querySelector("#injected-css-sv");
let Module = app.querySelector(".svelte-module");
Module.appendChild(styles);
*/
// app = app.attachShadow({mode: 'open'});
//export default app;